<template>
	<div class="pageRoot">
		<h1>TdsAppService Administration Homepage</h1>
		<p>Please select a menu item above.</p>
		<p title="Status refreshes automatically every 5 seconds">IP2Location Database Update Status: {{ip2LocationDbUpdateStatus}}</p>
		<p>IP2Location Database Update Manual Override: <button @click="manuallyTriggerIp2LocationDbUpdate">Trigger Now</button></p>
		<p title="Status refreshes automatically every 5 seconds">Passkey Provider List Update Status: {{passkeyProviderListUpdateStatus}}</p>
		<p>Passkey Provider List Update Manual Override: <button @click="manuallyTriggerPasskeyProviderListUpdate">Trigger Now</button></p>
	</div>
</template>

<script>
	import { SessionCheck } from 'appRoot/scripts/Util';
	import { GetIp2LocationDbUpdateStatus, ManuallyTriggerIp2LocationDbUpdate, GetPasskeyProviderListUpdateStatus, ManuallyTriggerPasskeyProviderListUpdate } from 'appRoot/api/AdminMiscData';

	export default {
		components: {},
		data()
		{
			return {
				ip2LocationDbUpdateStatus: "Status Not Available",
				ip2LocationStatusUpdateInterval: null,
				ip2LocationStatusIsUpdating: false,
				passkeyProviderListUpdateStatus: "Status Not Available",
				passkeyProviderListIsTriggering: false
			};
		},
		created()
		{
			SessionCheck();
			this.loadIp2LocationDbUpdateStatus();
			this.loadPasskeyProviderListUpdateStatus();
			this.ip2LocationStatusUpdateInterval = setInterval(() =>
			{
				this.loadIp2LocationDbUpdateStatus();
				this.loadPasskeyProviderListUpdateStatus();
			}, 5000);
		},
		beforeUnmount()
		{
			clearInterval(this.ip2LocationStatusUpdateInterval);
		},
		methods:
		{
			async loadIp2LocationDbUpdateStatus()
			{
				try
				{
					const data = await GetIp2LocationDbUpdateStatus();
					if (data.success)
						this.ip2LocationDbUpdateStatus = data.status;
					else
						this.ip2LocationDbUpdateStatus = "Error retrieving status: " + data.error;
				}
				catch (ex)
				{
					console.error(ex);
					this.ip2LocationDbUpdateStatus = "Error retrieving status: " + ex.message;
				}
			},
			async manuallyTriggerIp2LocationDbUpdate()
			{
				if (this.ip2LocationStatusIsUpdating)
					return;
				this.ip2LocationStatusIsUpdating = true;
				try
				{
					const data = await ManuallyTriggerIp2LocationDbUpdate();
					if (data.success)
					{
						alert("IP2Location database update has been manually triggered.");
					}
					else
					{
						alert("Error triggering update: " + data.error);
					}
				}
				catch (ex)
				{
					console.error(ex);
					alert("Error triggering update: " + ex.message);
				}
				finally
				{
					this.ip2LocationStatusIsUpdating = false;
				}
			},
			async loadPasskeyProviderListUpdateStatus()
			{
				try
				{
					const data = await GetPasskeyProviderListUpdateStatus();
					if (data.success)
						this.passkeyProviderListUpdateStatus = data.status;
					else
						this.passkeyProviderListUpdateStatus = "Error retrieving status: " + data.error;
				}
				catch (ex)
				{
					console.error(ex);
					this.passkeyProviderListUpdateStatus = "Error retrieving status: " + ex.message;
				}
			},
			async manuallyTriggerPasskeyProviderListUpdate()
			{
				if (this.passkeyProviderListIsTriggering)
					return;
				this.passkeyProviderListIsTriggering = true;
				try
				{
					const data = await ManuallyTriggerPasskeyProviderListUpdate();
					if (data.success)
					{
						alert("Passkey provider list update has been manually triggered.");
					}
					else
					{
						alert("Error triggering update: " + data.error);
					}
				}
				catch (ex)
				{
					console.error(ex);
					alert("Error triggering update: " + ex.message);
				}
				finally
				{
					this.passkeyProviderListIsTriggering = false;
				}
			}
		}
	}
</script>

<style scoped>
	.pageRoot
	{
		margin: 8px;
	}
</style>